export type Tone = {
    [index: number]: string;
    '0': string;
    '4': string;
    '6': string;
    '10': string;
    '12': string;
    '17': string;
    '20': string;
    '22': string;
    '24': string;
    '30': string;
    '40': string;
    '50': string;
    '60': string;
    '70': string;
    '80': string;
    '87': string;
    '90': string;
    '92': string;
    '94': string;
    '95': string;
    '96': string;
    '98': string;
    '99': string;
    '100': string;
};

export const PrimaryDefault: Tone = {
    '0': '#000000',
    '4': '#00101c',
    '6': '#001524',
    '10': '#001e30',
    '12': '#002236',
    '17': '#002d46',
    '20': '#003450',
    '22': '#003856',
    '24': '#003d5d',
    '30': '#004b71',
    '40': '#006495',
    '50': '#107eb8',
    '60': '#3d98d4',
    '70': '#5db3f1',
    '80': '#8fcdff',
    '87': '#badeff',
    '90': '#cbe6ff',
    '92': '#d6ebff',
    '94': '#e1efff',
    '95': '#e7f2ff',
    '96': '#ecf4ff',
    '98': '#f7f9ff',
    '99': '#fcfcff',
    '100': '#ffffff',
};

export const SecondaryDefault = {
    '0': '#000000',
    '4': '#01101c',
    '6': '#041521',
    '10': '#0d1d29',
    '12': '#11212e',
    '17': '#1c2c38',
    '20': '#22323f',
    '22': '#273644',
    '24': '#2b3b48',
    '30': '#394856',
    '40': '#50606f',
    '50': '#697988',
    '60': '#8293a2',
    '70': '#9dadbd',
    '80': '#b8c8d9',
    '87': '#cbdced',
    '90': '#d4e4f6',
    '92': '#d9eafc',
    '94': '#e1efff',
    '95': '#e7f2ff',
    '96': '#ecf4ff',
    '98': '#f7f9ff',
    '99': '#fcfcff',
    '100': '#ffffff',
};

export const TertiaryDefault = {
    '0': '#000000',
    '4': '#130826',
    '6': '#180d2b',
    '10': '#211634',
    '12': '#251a38',
    '17': '#302443',
    '20': '#362b4a',
    '22': '#3b2f4f',
    '24': '#3f3353',
    '30': '#4d4162',
    '40': '#66587b',
    '50': '#7f7195',
    '60': '#998ab0',
    '70': '#b4a4cb',
    '80': '#d0bfe7',
    '87': '#e4d3fc',
    '90': '#ecdcff',
    '92': '#f0e3ff',
    '94': '#f5eaff',
    '95': '#f7edff',
    '96': '#faf0ff',
    '98': '#fef7ff',
    '99': '#fffbff',
    '100': '#ffffff',
};

export const NeutralDefault = {
    '0': '#000000',
    '4': '#0c0e11',
    '6': '#111416',
    '10': '#1a1c1e',
    '12': '#1e2022',
    '17': '#282a2d',
    '20': '#2f3133',
    '22': '#333537',
    '24': '#37393c',
    '30': '#454749',
    '40': '#5d5e61',
    '50': '#76777a',
    '60': '#8f9194',
    '70': '#aaabae',
    '80': '#c6c6c9',
    '87': '#d9dadd',
    '90': '#e2e2e5',
    '92': '#e8e8eb',
    '94': '#edeef1',
    '95': '#f0f0f3',
    '96': '#f3f3f6',
    '98': '#f9f9fc',
    '99': '#fcfcff',
    '100': '#ffffff',
};

export const NeutralVariantDefault = {
    '0': '#000000',
    '4': '#090f14',
    '6': '#0e1419',
    '10': '#161c22',
    '12': '#1a2026',
    '17': '#252b30',
    '20': '#2b3137',
    '22': '#30353b',
    '24': '#343a40',
    '30': '#41474d',
    '40': '#595f65',
    '50': '#72787e',
    '60': '#8b9198',
    '70': '#a6acb3',
    '80': '#c1c7ce',
    '87': '#d5dae2',
    '90': '#dee3ea',
    '92': '#e3e9f0',
    '94': '#e9eef6',
    '95': '#ecf1f9',
    '96': '#eff4fc',
    '98': '#f7f9ff',
    '99': '#fcfcff',
    '100': '#ffffff',
};

export const ErrorDefault = {
    '0': '#000000',
    '4': '#280001',
    '6': '#310001',
    '10': '#410002',
    '12': '#490002',
    '17': '#5c0004',
    '20': '#690005',
    '22': '#710005',
    '24': '#790006',
    '30': '#93000a',
    '40': '#ba1a1a',
    '50': '#de3730',
    '60': '#ff5449',
    '70': '#ff897d',
    '80': '#ffb4ab',
    '87': '#ffcfc9',
    '90': '#ffdad6',
    '92': '#ffe2de',
    '94': '#ffe9e6',
    '95': '#ffedea',
    '96': '#fff0ee',
    '98': '#fff8f7',
    '99': '#fffbff',
    '100': '#ffffff',
};
